import * as z from 'zod';

export const ResolveNotificationConfigRequest = z.object({
  notificationConfigId: z
    .string()
    .describe('Id of the NotificationConfig to retrieve')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
});
export const ResolveNotificationConfigResponse = z.object({
  notificationConfig: z
    .object({
      _id: z
        .string()
        .describe('Event ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      revision: z
        .string()
        .regex(/^-?\d+$/, 'Must be a valid Int64 string')
        .describe(
          'Represents the current state of an item. Each time the item is modified, its `revision` changes. for an update operation to succeed, you MUST pass the latest revision.'
        )
        .optional()
        .nullable(),
      _createdDate: z
        .date()
        .describe('Represents the time this NotificationConfig was created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe(
          'Represents the time this NotificationConfig was last updated.'
        )
        .optional()
        .nullable(),
      rsvpConfirmation: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .describe('Predefined id of the notification type.')
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .describe(
              'Desired timing of the notification in hours respectfully to event start time.\nFor example if value is 0 then notification is sent at the start of the event.'
            )
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('Rsvp confirmation.')
        .optional(),
      newSpotsAvailable: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .describe('Predefined id of the notification type.')
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .describe(
              'Desired timing of the notification in hours respectfully to event start time.\nFor example if value is 0 then notification is sent at the start of the event.'
            )
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('New spots available.')
        .optional(),
      eventCancelation: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .describe('Predefined id of the notification type.')
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .describe(
              'Desired timing of the notification in hours respectfully to event start time.\nFor example if value is 0 then notification is sent at the start of the event.'
            )
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('Event cancelation.')
        .optional(),
      upcomingEventReminder: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .describe('Predefined id of the notification type.')
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .describe(
              'Desired timing of the notification in hours respectfully to event start time.\nFor example if value is 0 then notification is sent at the start of the event.'
            )
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('Event reminder.')
        .optional(),
      orderConfirmation: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .describe('Predefined id of the notification type.')
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .describe(
              'Desired timing of the notification in hours respectfully to event start time.\nFor example if value is 0 then notification is sent at the start of the event.'
            )
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('Order confirmation.')
        .optional(),
      ticketConfirmation: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .describe('Predefined id of the notification type.')
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .describe(
              'Desired timing of the notification in hours respectfully to event start time.\nFor example if value is 0 then notification is sent at the start of the event.'
            )
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('Ticket confirmation.')
        .optional(),
      invoice: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .describe('Predefined id of the notification type.')
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .describe(
              'Desired timing of the notification in hours respectfully to event start time.\nFor example if value is 0 then notification is sent at the start of the event.'
            )
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('Invoice.')
        .optional(),
      orderConfirmationWithTicketsLink: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .describe('Predefined id of the notification type.')
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .describe(
              'Desired timing of the notification in hours respectfully to event start time.\nFor example if value is 0 then notification is sent at the start of the event.'
            )
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('Order confirmation with tickets link.')
        .optional(),
    })
    .describe('The retrieved NotificationConfig')
    .optional(),
});
export const UpsertNotificationConfigRequest = z.object({
  _id: z
    .string()
    .describe('Event ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  notificationConfig: z
    .object({
      _id: z
        .string()
        .describe('Event ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      revision: z
        .string()
        .regex(/^-?\d+$/, 'Must be a valid Int64 string')
        .describe(
          'Represents the current state of an item. Each time the item is modified, its `revision` changes. for an update operation to succeed, you MUST pass the latest revision.'
        )
        .optional()
        .nullable(),
      _createdDate: z
        .date()
        .describe('Represents the time this NotificationConfig was created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe(
          'Represents the time this NotificationConfig was last updated.'
        )
        .optional()
        .nullable(),
      rsvpConfirmation: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('Rsvp confirmation.')
        .optional(),
      newSpotsAvailable: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('New spots available.')
        .optional(),
      eventCancelation: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('Event cancelation.')
        .optional(),
      upcomingEventReminder: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('Event reminder.')
        .optional(),
      orderConfirmation: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('Order confirmation.')
        .optional(),
      ticketConfirmation: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('Ticket confirmation.')
        .optional(),
      invoice: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('Invoice.')
        .optional(),
      orderConfirmationWithTicketsLink: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('Order confirmation with tickets link.')
        .optional(),
    })
    .describe('NotificationConfig to be upserted'),
});
export const UpsertNotificationConfigResponse = z.object({
  notificationConfig: z
    .object({
      _id: z
        .string()
        .describe('Event ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      revision: z
        .string()
        .regex(/^-?\d+$/, 'Must be a valid Int64 string')
        .describe(
          'Represents the current state of an item. Each time the item is modified, its `revision` changes. for an update operation to succeed, you MUST pass the latest revision.'
        )
        .optional()
        .nullable(),
      _createdDate: z
        .date()
        .describe('Represents the time this NotificationConfig was created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe(
          'Represents the time this NotificationConfig was last updated.'
        )
        .optional()
        .nullable(),
      rsvpConfirmation: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .describe('Predefined id of the notification type.')
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .describe(
              'Desired timing of the notification in hours respectfully to event start time.\nFor example if value is 0 then notification is sent at the start of the event.'
            )
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('Rsvp confirmation.')
        .optional(),
      newSpotsAvailable: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .describe('Predefined id of the notification type.')
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .describe(
              'Desired timing of the notification in hours respectfully to event start time.\nFor example if value is 0 then notification is sent at the start of the event.'
            )
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('New spots available.')
        .optional(),
      eventCancelation: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .describe('Predefined id of the notification type.')
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .describe(
              'Desired timing of the notification in hours respectfully to event start time.\nFor example if value is 0 then notification is sent at the start of the event.'
            )
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('Event cancelation.')
        .optional(),
      upcomingEventReminder: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .describe('Predefined id of the notification type.')
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .describe(
              'Desired timing of the notification in hours respectfully to event start time.\nFor example if value is 0 then notification is sent at the start of the event.'
            )
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('Event reminder.')
        .optional(),
      orderConfirmation: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .describe('Predefined id of the notification type.')
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .describe(
              'Desired timing of the notification in hours respectfully to event start time.\nFor example if value is 0 then notification is sent at the start of the event.'
            )
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('Order confirmation.')
        .optional(),
      ticketConfirmation: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .describe('Predefined id of the notification type.')
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .describe(
              'Desired timing of the notification in hours respectfully to event start time.\nFor example if value is 0 then notification is sent at the start of the event.'
            )
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('Ticket confirmation.')
        .optional(),
      invoice: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .describe('Predefined id of the notification type.')
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .describe(
              'Desired timing of the notification in hours respectfully to event start time.\nFor example if value is 0 then notification is sent at the start of the event.'
            )
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('Invoice.')
        .optional(),
      orderConfirmationWithTicketsLink: z
        .object({
          notificationType: z
            .enum([
              'EMAIL_RSVP_CONFIRMATION',
              'EMAIL_NEW_SPOTS_AVAILABLE',
              'EMAIL_EVENT_CANCELATION',
              'EMAIL_UPCOMING_EVENT_REMINDER',
              'EMAIL_ORDER_CONFIRMATION',
              'EMAIL_TICKET_CONFIRMATION',
              'EMAIL_INVOICE',
            ])
            .describe('Predefined id of the notification type.')
            .optional(),
          template: z
            .object({
              subject: z
                .string()
                .describe('Email subject.')
                .min(1)
                .max(100)
                .optional()
                .nullable(),
              body: z
                .string()
                .describe('Plain text message body.')
                .min(1)
                .max(1000)
                .optional()
                .nullable(),
              descriptionLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Description link visibility and display text')
                .optional(),
              calendarLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe('Calendar link visibility and display text')
                .optional(),
              onlineConferencingLink: z
                .object({
                  display: z
                    .boolean()
                    .describe('When true the link is added to the email.')
                    .optional()
                    .nullable(),
                  linkText: z
                    .string()
                    .describe('Text of the link.')
                    .max(60)
                    .optional()
                    .nullable(),
                })
                .describe(
                  'Online conferencing link visibility and display text'
                )
                .optional(),
              includeTickets: z
                .boolean()
                .describe(
                  'When true the tickets are attached to the order confirmation email.'
                )
                .optional()
                .nullable(),
            })
            .describe('Email template values.')
            .optional(),
          reminderTime: z
            .enum([
              'INSTANT',
              'BEFORE_1_DAY',
              'BEFORE_3_DAYS',
              'BEFORE_1_WEEK',
              'BEFORE_1_HOUR',
              'BEFORE_30_MINUTES',
            ])
            .describe(
              'Desired timing of the notification in hours respectfully to event start time.\nFor example if value is 0 then notification is sent at the start of the event.'
            )
            .optional(),
          sendingEnabled: z
            .boolean()
            .describe(
              'When true the notification will be sent when certain trigger occurs.'
            )
            .optional()
            .nullable(),
        })
        .describe('Order confirmation with tickets link.')
        .optional(),
    })
    .describe('The upserted NotificationConfig')
    .optional(),
});
export const TriggerNotificationRequest = z.object({
  options: z.intersection(
    z.object({}),
    z.intersection(
      z.xor([
        z.object({
          pushNotificationType: z.never().optional(),
          emailNotificationType: z.enum([
            'EMAIL_RSVP_CONFIRMATION',
            'EMAIL_NEW_SPOTS_AVAILABLE',
            'EMAIL_EVENT_CANCELATION',
            'EMAIL_UPCOMING_EVENT_REMINDER',
            'EMAIL_ORDER_CONFIRMATION',
            'EMAIL_TICKET_CONFIRMATION',
            'EMAIL_INVOICE',
          ]),
        }),
        z.object({
          emailNotificationType: z.never().optional(),
          pushNotificationType: z.enum([
            'PUSH_EVENT_UPDATED',
            'PUSH_EVENT_CANCELATION',
            'PUSH_UPCOMING_EVENT_REMINDER',
            'PUSH_EVENT_CREATED',
          ]),
        }),
      ]),
      z.xor([
        z.object({
          orderGuest: z.never().optional(),
          eventGuests: z.never().optional(),
          ticketGuest: z.never().optional(),
          rsvpGuest: z
            .object({
              eventId: z
                .string()
                .describe('Event id')
                .regex(
                  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                  'Must be a valid GUID'
                )
                .optional(),
              rsvpId: z
                .string()
                .describe('Rsvp id')
                .regex(
                  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                  'Must be a valid GUID'
                )
                .optional(),
            })
            .describe('Rsvp guest info'),
        }),
        z.object({
          rsvpGuest: z.never().optional(),
          eventGuests: z.never().optional(),
          ticketGuest: z.never().optional(),
          orderGuest: z
            .object({
              eventId: z
                .string()
                .describe('Event id')
                .regex(
                  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                  'Must be a valid GUID'
                )
                .optional(),
              orderNumber: z
                .string()
                .describe('Order number')
                .max(36)
                .optional(),
            })
            .describe('Order guest info'),
        }),
        z.object({
          rsvpGuest: z.never().optional(),
          orderGuest: z.never().optional(),
          ticketGuest: z.never().optional(),
          eventGuests: z
            .object({
              eventId: z
                .string()
                .describe('Event id')
                .regex(
                  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                  'Must be a valid GUID'
                )
                .optional(),
            })
            .describe('Event guests info'),
        }),
        z.object({
          rsvpGuest: z.never().optional(),
          orderGuest: z.never().optional(),
          eventGuests: z.never().optional(),
          ticketGuest: z
            .object({
              eventId: z
                .string()
                .describe('Event id')
                .regex(
                  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                  'Must be a valid GUID'
                )
                .optional(),
              orderNumber: z
                .string()
                .describe('Order number')
                .max(36)
                .optional()
                .nullable(),
              ticketNumber: z.array(z.string()).min(1).max(100).optional(),
            })
            .describe('Ticket guests info'),
        }),
      ])
    )
  ),
});
export const TriggerNotificationResponse = z.object({});
